import { apiClient } from 'client/core/network/apiClient';
import { ICreateAccessTokenDto } from 'common/dto/AuthDto';

export const AuthApi = {
  /** Creazione dell'access token per il login */
  createAccessToken: (data: ICreateAccessTokenDto) =>
    apiClient.request().post('/auth/access-token', data),
  refreshToken: () => apiClient.request().post('/auth/refresh-token'),
  logout: () => apiClient.request().post('/auth/logout')
};
